import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
} from '@chakra-ui/react'
import { lang } from '../../../Utils';
import Delivery from './Delivery';
import HandlingUnit from './HandlingUnit';
import LineDetail from './LineDetail';
import Scheduling from './Scheduling';

const SidePanelDelivery = ({ isOpen, onClose }) => <Drawer
  isOpen={isOpen}
  placement='right'
  onClose={onClose}
  size="full"
>
  <DrawerOverlay />
  <DrawerContent className="bf-sidepanel-detail" maxW={'70%'}>
    <DrawerCloseButton />
    <DrawerHeader>{lang('Handling Unit')}</DrawerHeader>
    <DrawerBody p={0} h={'100%'} className="bf-sidepanel-body">
      <Tabs className="bf-sidepanel-tabs">
        <TabList>
          <Tab className="bf-tabs-placeholder">&nbsp;</Tab>
        </TabList>
        <TabPanels className="bf-sidepanel-panels">
          <TabPanel className="bf-sidepanel-panel"><HandlingUnit /></TabPanel>
        </TabPanels>
      </Tabs>
    </DrawerBody>
  </DrawerContent>
</Drawer>

export default SidePanelDelivery;